import TextLink, { headlessLinkProps } from './TextLink'
export * from './types'
export { TextLink, headlessLinkProps }
